import { Translator } from 'Translator';
import Load from 'components/Load';
import LoadingDots from 'components/LoadingDots';
import LoggedOut from 'components/environments/LoggedOut';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import Notfound from 'modules/errorpages/Notfound';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';
import { useUser } from '~/authentication/store';

const HostInbox = Load(
  () => import(/* webpackChunkName: "host-inbox" */ './components/HostInbox'),
);

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const { isLoggedIn, loading, isHost, isAdmin } = useUser();

  if (!loading && !isLoggedIn) {
    return (
      <LoggedOut title="Your updates will show up here. Join Withlocals" />
    );
  }

  if (loading) {
    return <LoadingDots />;
  }

  if (!isHost && !isAdmin) {
    return (
      <Redirect
        to={generatePathnameWithLangCode('/', Translator.getLanguageCode())}
      />
    );
  }

  return (
    <Switch>
      <NavigationableLayout
        key="host-inbox"
        path={`${path}/`}
        hideFooter
        showBottomNavigation
        noNavbar={isCordova()}
        showZendesk={false}
        component={HostInbox}
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes = (
  <Route path={`${basePath}/host/updates-center`}>
    <>
      <SubRoutes />
      <AppBottomPushDown />
    </>
  </Route>
);

export default routes;
